export type AssetErrorCode =
  | 'ASSET_EMPTY'
  | 'ASSET_TOO_LARGE'
  | 'ASSET_FORMAT_UNSUPPORTED'
  | 'ASSET_HEIC_UNSUPPORTED'
  | 'ASSET_MIME_MISMATCH'
  | 'ASSET_CORRUPT'
  | 'ASSET_DIMENSIONS_INVALID'
  | 'ASSET_PIXEL_LIMIT'
  | 'ASSET_SVG_UNSAFE'
  | 'ASSET_PDF_ENCRYPTED_OR_INVALID'
  | 'ASSET_PDF_PAGE_LIMIT'
  | 'ASSET_PDF_PAGE_OUT_OF_RANGE'
  | 'ASSET_NOT_FOUND'
  | 'ASSET_OBJECT_URL_UNAVAILABLE'
  | 'ASSET_INDEXEDDB_UNAVAILABLE'
  | 'ASSET_PDF_PREVIEW_REQUIRES_DOM'
  | 'ASSET_PDF_PREVIEW_FAILED';

export class AssetError extends Error {
  readonly code: AssetErrorCode;
  readonly details: Readonly<Record<string, unknown>>;

  constructor(
    code: AssetErrorCode,
    message: string,
    details: Readonly<Record<string, unknown>> = {},
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = 'AssetError';
    this.code = code;
    this.details = details;
  }
}

export function assetNotFound(assetId: string): AssetError {
  return new AssetError('ASSET_NOT_FOUND', 'No se encontro el activo solicitado.', {
    assetId,
  });
}
